<template>
  <v-app>
    <v-main>
      <CookieBanner ref="cookieBanner" />
      <cHeader />
      <div class="fixHeader"></div>
      <div>
        <router-view/>
      </div>
      <cFooter />
    </v-main>
  </v-app>
</template>

<style>
</style>

<script>
  import CookieBanner from './components/cookie.vue';
  import {
    initConsentMode,
    registerScript,
    applyConsent
  } from '../public/Resources/script/cookieConsent.js';

  export default {
    name: 'App',
    data: () => ({}),
    mounted() {
      // 1. Initialiser Google Consent Mode (tout denied par défaut)
      initConsentMode();

      // 2. Enregistrer les scripts par catégorie
      // analytical → Google Analytics via GooglePerformance() de tools.js
      registerScript('analytical', function() {
        GooglePerformance('G-86F1LTW6D1');
      });

      // advertisement → Google Tag Manager via GoogleAdvertising() de tools.js
      registerScript('advertisement', function() {
        GoogleAdvertising(window, document, 'script', 'dataLayer', 'GTM-5PXL23C8');
      });

      // functional et performance — à compléter selon tes besoins
      registerScript('functional',    function() { console.log('[Cookie] functional accepté'); });
      registerScript('performance',   function() { console.log('[Cookie] performance accepté'); });

      // 3. Appliquer le consentement sauvegardé
      applyConsent();

      // 4. Écouter l'event bus global pour ouvrir le banner (footer, header, etc.)
      if (window.$App && window.$App.event) {
        window.$App.event.$on('openCookie', () => {
          this.openCookieBanner();
        });
      }
    },
    beforeDestroy() {
      if (window.$App && window.$App.event) {
        window.$App.event.$off('openCookie');
      }
    },
    methods: {
      openCookieBanner() {
        if (this.$refs.cookieBanner) {
          this.$refs.cookieBanner.reopenBanner();
        }
      },
    },
    components: { CookieBanner },
  }
</script>